var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.58584L11.7928 7.79292C12.1833 7.40238 12.8164 7.40236 13.207 7.79286C13.5975 8.18337 13.5975 8.81654 13.207 9.20708L9.70714 12.7073C9.5196 12.8948 9.26523 13.0002 9.00001 13.0002C8.73478 13.0002 8.48041 12.8948 8.29287 12.7073L4.79287 9.20709C4.40236 8.81655 4.40238 8.18339 4.79291 7.79287C5.18345 7.40236 5.81661 7.40238 6.20713 7.79291L8 9.58588V1C8 0.447715 8.44771 0 9 0C9.55229 0 10 0.447715 10 1V9.58584Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9C1.55228 9 2 9.44771 2 10L2 16H16V10C16 9.44771 16.4477 9 17 9C17.5523 9 18 9.44771 18 10V16C18 17.1046 17.1046 18 16 18H2C0.895431 18 0 17.1046 0 16V10C0 9.44771 0.447715 9 1 9Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic-download.a04677268c6d9934adc9fabcc1a0bd98.svg";
export { ForwardRef as ReactComponent };